import React from 'react';
import { HexColorPicker } from 'react-colorful';
import { ActionButton, DialogTrigger, Flex, Grid, repeat, View, } from '@adobe/react-spectrum';
import { toCSSColor } from '@printu/geom';
import ColorPalette from '@spectrum-icons/workflow/ColorPalette';
const Consts = {
    commitDelay: 600,
};
const ColorPicker = (props) => {
    const shouldCommit = React.useRef(true);
    const debounceTimout = React.useRef();
    const { color, column, onChange } = props;
    const onSelectInteractive = React.useCallback((value) => {
        onChange(value, shouldCommit.current);
        shouldCommit.current = false;
        if (debounceTimout.current) {
            clearTimeout(debounceTimout.current);
        }
        debounceTimout.current = setTimeout(() => {
            shouldCommit.current = true;
        }, Consts.commitDelay);
    }, [onChange]);
    return (React.createElement(Flex, { direction: "column", gap: "size-100", gridColumn: `${column}`, gridRow: "1 / span 2" },
        React.createElement(ActionButton, { isQuiet: true, "data-test-id": "color-picker-selected", UNSAFE_style: {
                backgroundColor: toCSSColor(color),
                borderRadius: '8px',
            }, onPress: () => onChange(color, true) }),
        React.createElement(DialogTrigger, { type: "popover", placement: "right", hideArrow: true },
            React.createElement(ActionButton, { "data-test-id": "color-pallete-trigger" },
                React.createElement(ColorPalette, null)),
            React.createElement(View, { padding: "size-200" },
                React.createElement(HexColorPicker, { "data-test-id": "color-pallete", color: color, onChange: onSelectInteractive })))));
};
export const ColorsGrid = (props) => {
    const { color, showPicker, colors, colsCount, onSelect, onChange, rowsCount = 2, } = props;
    const columnsCount = (colsCount !== null && colsCount !== void 0 ? colsCount : Math.trunc(Math.round(colors.length / rowsCount))) +
        (showPicker ? 1 : 0);
    return (React.createElement(Grid, { columns: repeat(columnsCount, 'size-400'), rows: repeat(rowsCount, 'size-400'), justifyContent: "stretch", gap: "size-100" },
        colors.map((swatchColor, index) => (React.createElement(ActionButton, { key: swatchColor, "data-test-id": `color-swatch-${index}`, isQuiet: true, UNSAFE_style: {
                backgroundColor: toCSSColor(swatchColor),
                borderRadius: '8px',
            }, onPress: () => onSelect(swatchColor) }))),
        showPicker && onChange && (React.createElement(ColorPicker, { column: columnsCount, color: color, onChange: onChange }))));
};
